import {
  UseMutationResult,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { unlikeMap } from '~map-preview/api/unlikeMap'
import { decreaseLikes, setLiked, useMapId } from '~map-preview/states/map'

const useUnlikeMap = () => {
  const dispatch = useDispatch()
  const mapId = useMapId()
  const query = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (id: string) => {
      return unlikeMap({ id })
    },
    onMutate: () => {
      dispatch(setLiked(false))
      dispatch(decreaseLikes())
    },
    onSuccess: () => {
      query.invalidateQueries({ queryKey: ['getMapById', mapId] })
    }
  })

  return mutation as UseMutationResult<unknown>
}

export { useUnlikeMap }
